import { CloseOutlined, Save } from "@mui/icons-material";
import { Button, DialogContent, DialogTitle, IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function CustomDialog({
  open = false,
  children = "",
  title = "",
  className = "",
  firstText = "Save",
  secondText = "Close",
  type = "",
  isAction = false,
  maxWidth = "sm",
  onClose = () => {},
  onSave = () => {},
  showSaveIcon = true,
  titleClass = "",
  closeIcon = true,
  ...props
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth={true}
      open={open}
      maxWidth={maxWidth}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title"
      PaperProps={{ elevation: 0 }}
    >
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="font-railroad italic"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          X
        </IconButton>
      ) : null}
      {title && (
        <DialogTitle className={`font-bold ${titleClass}`}>{title}</DialogTitle>
      )}
      <DialogContent className={`p-6 ${!title ? "mt-8" : ""}`}>
        {children}
        {isAction ? null : (
          <div className="flex justify-center pt-10 pb-5">
            <Button
              className="mx-2 px-4 py-3 font-bold font-zing text-base"
              onClick={onSave}
              variant="contained"
              color="primary"
              size="small"
              startIcon={showSaveIcon ? <Save /> : undefined}
            >
              {type === "deleteSubscription" ? "Yes, Delete my Box" : firstText}
            </Button>
            <Button
              className="mx-2 px-4 py-3 font-bold font-zing text-base"
              onClick={onClose}
              variant="outlined"
              size="small"
              color="secondary"
              startIcon={closeIcon ? <CloseOutlined /> : null}
            >
              {type === "deleteSubscription" ? "No, Keep my Box" : secondText}
            </Button>
          </div>
        )}
      </DialogContent>
      {/* {isAction ? (
        ""
      ) : (
        <DialogActions>
          <Button
            className="mx-2 px-4 py-3 font-bold"
            onClick={onSave}
            variant="contained"
            color="primary"
            size="small"
            startIcon={showSaveIcon ? <Save /> : undefined}
          >
            {type === "deleteSubscription" ? "Yes, Delete my Box" : firstText}
          </Button>
          <Button
            className="mx-2 px-4 py-3 font-bold"
            onClick={onClose}
            variant="outlined"
            size="small"
            color="secondary"
          >
            {type === "deleteSubscription" ? "No, Keep my Box" : secondText}
          </Button>
        </DialogActions>
      )} */}
    </Dialog>
  );
}
